/**
 * 日志类型
 */
export default {
  employee: 1,
  department: 2,
  position: 3,
}
